import { Suspense } from 'react'

import Spinner from '../spinner'

type DefaultSuspenseProps = {
    children: React.ReactNode
}
export default function DefaultSuspense({ children }: DefaultSuspenseProps) {
    return <Suspense fallback={<Spinner size="sm" absolute />}>{children}</Suspense>
}
